package com.hyperether.goodjob.navigation

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.navigation.NavHostController
import com.hyperether.goodjob.log
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.repository.prefs.PrefsManager
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.briefcase
import com.hyperether.goodjob.resources.briefcase_unselect
import com.hyperether.goodjob.resources.calendar
import com.hyperether.goodjob.resources.calendar_unselect
import com.hyperether.goodjob.resources.dahboard
import com.hyperether.goodjob.resources.dahboard_unselect
import com.hyperether.goodjob.resources.employees
import com.hyperether.goodjob.resources.employees_unselect
import com.hyperether.goodjob.resources.map
import com.hyperether.goodjob.resources.map_unselect
import com.hyperether.goodjob.resources.user_check
import com.hyperether.goodjob.resources.user_check_unselect
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun AndroidNav(navController: NavHostController, prefsManager: PrefsManager) {
    val user by prefsManager.userFlow.collectAsState()
    var selectedTabIndex by remember { mutableStateOf(0) }
    var previousTabIndex by remember { mutableStateOf(0) }

    val navItems =
        if (user?.role.equals(Role.superAdmin.name, ignoreCase = true) ||
            user?.role.equals(Role.admin.name, ignoreCase = true) ||
            user?.role.equals(Role.manager.name, ignoreCase = true)
        ) listOf(
            NavItem(
                iconResId = Res.drawable.dahboard,
                unselectedIconResId = Res.drawable.dahboard_unselect,
                route = Dashboard
            ),
            NavItem(
                iconResId = Res.drawable.employees,
                unselectedIconResId = Res.drawable.employees_unselect,
                route = Users
            ),
            NavItem(
                iconResId = Res.drawable.briefcase,
                unselectedIconResId = Res.drawable.briefcase_unselect,
                route = Jobs
            ),
            NavItem(
                iconResId = Res.drawable.calendar,
                unselectedIconResId = Res.drawable.calendar_unselect,
                route = Scheduler
            ),
            NavItem(
                iconResId = Res.drawable.user_check,
                unselectedIconResId = Res.drawable.user_check_unselect,
                route = Contacts
            ),
            NavItem(
                iconResId = Res.drawable.map,
                unselectedIconResId = Res.drawable.map_unselect,
                route = Map
            )
        ) else {
            listOf(
                NavItem(
                    iconResId = Res.drawable.dahboard,
                    unselectedIconResId = Res.drawable.dahboard_unselect,
                    route = Dashboard
                ),
                NavItem(
                    iconResId = Res.drawable.briefcase,
                    unselectedIconResId = Res.drawable.briefcase_unselect,
                    route = Jobs
                ),
                NavItem(
                    iconResId = Res.drawable.calendar,
                    unselectedIconResId = Res.drawable.calendar_unselect,
                    route = Scheduler
                ),
                NavItem(
                    iconResId = Res.drawable.map,
                    unselectedIconResId = Res.drawable.map_unselect,
                    route = Map
                )
            )
        }

    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceAround,
        verticalAlignment = Alignment.CenterVertically
    ) {
        navItems.forEachIndexed { index, item ->
            IconButton(onClick = {
                selectedTabIndex = index
                log.d("Navigation", { "selectedTabIndex: $selectedTabIndex" })
                navController.safeNavigate(item.route)
            }) {
                Column(
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    val iconRes =
                        if (selectedTabIndex == index) item.iconResId else item.unselectedIconResId
                    log.d(
                        "Navigation",
                        { "selectedTabIndex: $selectedTabIndex iconRes: $iconRes" })
                    val icon = painterResource(iconRes)
                    Image(
                        painter = icon,
                        contentDescription = null,
                    )
                }
            }
        }
    }

    LaunchedEffect(navController, navItems) {
        navController.currentBackStackEntryFlow.collect { backStackEntry ->
            val currentRoute = backStackEntry.destination.route
            val tabIndex = navItems.indexOfFirst { it.route.route == currentRoute }
            println("Navigation -> Current route: $currentRoute, Tab index: $tabIndex")
            if (tabIndex != -1) {
                selectedTabIndex = tabIndex
                previousTabIndex = tabIndex
                log.d("Navigation", { "Current route: $currentRoute, Tab index: $tabIndex" })
            } else {
                selectedTabIndex = previousTabIndex
            }
        }
    }
}

data class NavItem(
    val iconResId: DrawableResource,
    val unselectedIconResId: DrawableResource,
    val route: RouteScreen
)
